import { createFileRoute } from '@tanstack/react-router'

import { NotificationsSettingsPage } from '@/features/settings/section-pages'

export const Route = createFileRoute('/_app/settings/notifications')({
  component: NotificationsSettingsPage,
})
